<script setup lang="ts">
const props = defineProps<{
  modelValue: boolean;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
}>();

const value = computed({
  get: () => {
    return props.modelValue;
  },
  set: (val: boolean) => {
    emit("update:modelValue", val);
  },
});
</script>

<template>
  <div class="expand-search flex items-center py-2">
    <FormCheck
      v-model="value"
      name="expandAllSongs"
      :label="$t('SV.MES_SelectBoxExpand')"
      class="apply-filter-checkbox"
      data-user-search-activity="Expanded Search"
    />
    <Tooltip
      :text="$t('SV.MES_ExpandSearchTooltip')"
      class="ms-1"
    >
      <FAIcon class="fa-light fa-question-circle text-primary" />
    </Tooltip>
  </div>
</template>

<style scoped lang="postcss"></style>
